import React from 'react';
import PropTypes from 'prop-types';
import PopUp from '@/components/Modal/PopUp';
import './style';

class Loading extends React.PureComponent {
  static propTypes = {
    hide: PropTypes.func,
    txt: PropTypes.string,
  };

  componentDidMount() {
  }

  handleHideModal = (e) => {
    e.preventDefault();
    this.props.hide();
  };

  render() {
    return (
      <PopUp>
        <div className="loading">
          <div className="loading-pic" />
          <div>{`${this.props.txt}...`}</div>
        </div>
      </PopUp>
    );
  }
}

export default Loading;
